import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Video = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='m15.553 9.724 4-2A1 1 0 0 1 21 8.618v6.764a1 1 0 0 1-1.447.894l-4-2a1 1 0 0 1-.553-.894v-2.764a1 1 0 0 1 .553-.894'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </g>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 7A2.75 2.75 0 0 1 5 4.25h8A2.75 2.75 0 0 1 15.75 7v1.786l3.467-1.733a1.75 1.75 0 0 1 2.533 1.565v6.764a1.75 1.75 0 0 1-2.533 1.565l-3.467-1.733V17A2.75 2.75 0 0 1 13 19.75H5A2.75 2.75 0 0 1 2.25 17z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
